import { useEffect, useState } from "react";
import {
  createHighlightOwner,
  type HighlightOwner,
} from "../utils/highlightRegistry";

/**
 * A highlight owner for the component's lifetime: everything it published is
 * cleared when the component unmounts.
 */
export function useHighlightOwner(): HighlightOwner {
  const [owner] = useState(createHighlightOwner);
  useEffect(() => () => owner.clearAll(), [owner]);
  return owner;
}
